import type { PropsWithChildren } from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert, AlertTitle } from '@mui/material';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import type { FallbackProps } from 'react-error-boundary';
import { useLocation } from 'react-router';

const BasicErrorLayout = ({ error }: FallbackProps) => (
    <Alert severity="error">
        <AlertTitle>
            <FormattedMessage
                defaultMessage={`We're sorry, something went wrong. Try reloading the page.`}
            />
        </AlertTitle>
        {error.message}
    </Alert>
);
export default function ErrorBoundary(props: PropsWithChildren<unknown>) {
    const location = useLocation();
    return (
        <ReactErrorBoundary
            FallbackComponent={BasicErrorLayout}
            resetKeys={[location]}
            {...props}
        />
    );
}
